var P = /* @__PURE__ */ ((E) => (E[E.IN_PROGRESS = 1] = "IN_PROGRESS", E[E.EXPIRED = 2] = "EXPIRED", E[E.CYCLE_END = 3] = "CYCLE_END", E[E.COMPLETE = 4] = "COMPLETE", E))(P || {});
export {
  P as StampCardStatus
};
//# sourceMappingURL=stampcard.js.map
